// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"3515864e","37":"1e05a26f","229":"920d3c8a","247":"33581631","482":"2dfcd49d","494":"6de8671f","503":"d11e46ed","570":"77354801","583":"2e4ac474","645":"3bd17575","689":"46fe4ed2","781":"46449b62"}[chunkId] + ".chunk.js";
};